import { render, staticRenderFns } from "./OrderCutOrder.vue?vue&type=template&id=23c47e2c&scoped=true&"
import script from "./OrderCutOrder.vue?vue&type=script&lang=js&"
export * from "./OrderCutOrder.vue?vue&type=script&lang=js&"
import style0 from "./OrderCutOrder.vue?vue&type=style&index=0&id=23c47e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c47e2c",
  null
  
)

export default component.exports